import { formatCount } from '@/domain/warehouse';
import './LibraryList.css';

type LibraryMeterProps = {
  done: number;
  total: number;
  /** Words after "9 of 14", e.g. "picked", "in" or "recorded". */
  suffix?: string;
  /** Replaces the "9 of 14 …" text, e.g. "Builds 14 · limited by 3K projector". */
  label?: string;
  /** 'warn' tints the bar (short, overdue). */
  tone?: 'warn' | null;
  /** Class prefix for the meter, its track and fill; pages with their own meter styles pass theirs. */
  classPrefix?: string;
};

/** "9 of 14 picked" with a small bar; the text carries the meaning, the bar is decoration. */
export default function LibraryMeter({ done, total, suffix, label, tone, classPrefix = 'library-meter' }: LibraryMeterProps) {
  const percent = total > 0 ? Math.min(100, Math.max(0, (done / total) * 100)) : 0;
  return (
    <span className={classPrefix} data-tone={tone ?? undefined}>
      <span className={`${classPrefix}__track`} aria-hidden="true">
        <span className={`${classPrefix}__fill`} style={{ width: `${percent}%` }} />
      </span>
      <span>{label ?? `${formatCount(done)} of ${formatCount(total)}${suffix ? ` ${suffix}` : ''}`}</span>
    </span>
  );
}
